import MuiTabs from '@mui/material/Tabs';
import MuiTab from '@mui/material/Tab';

import theme from 'src/utils/theme';
import { styledComponent } from 'src/utils/styled';

export const Tabs = styledComponent(MuiTabs)`
    position: relative;
    .MuiTabs-indicator {
        background-color: ${theme.palette.primary.main};
        height: 0.0625rem;
    }
    &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-bottom: 0.0625rem solid ${theme.palette.divider};
    }
`;

export const Tab = styledComponent(MuiTab)`
    text-transform: none;
    font-size: 1.125rem;
    color: ${theme.palette.primary.light};
    min-width: 0;
    white-space: nowrap;
    &.Mui-selected {
        color: ${theme.palette.primary.main};
        font-weight: bold;
    }
`;
